import React from 'react';
import './depositList.css';
import { useDispatch, useSelector } from "react-redux";
import { setDepositListAction, setDepositFormAction, contextAction } from "../../redux/rootReducer";
import { DEPOSIT_FORM_INITIAL, DEPOSIT_LIST_INITIAL } from "../../redux/initialStateConstant";
import ContextMenu from "../ContextMenu/ContextMenu";
import { getDepositByIdSagaAction, removeDepositSagaAction } from "../../redux/sagaActions";

const DepositsList = () => {
    const dispatch = useDispatch();
    const deposit_list = useSelector(state => state.deposit_list);
    const context = useSelector(state => state.context);

    let data = null;
    if (deposit_list.list?.length  && context) {
        data = deposit_list.list.find(elem => elem.id === context);
    }

    const menu = [
        {
            id: '1',
            caption: 'Редактировать',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                dispatch(getDepositByIdSagaAction({ id: data.id }));
            }
        },
        {
            id: '2',
            caption: 'Удалить',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                // Подтверждение удаления платежа
                if (window.confirm('Вы действительно хотите удалить депозит?')) {
                    dispatch(removeDepositSagaAction({ deposit_id: data.id }));
                }
            }
        }
    ];

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => dispatch(setDepositListAction(DEPOSIT_LIST_INITIAL)) }/>
                        <div className="form__title">Депозиты</div>
                    </div>
                    <div className="form__field">
                        {
                            deposit_list.list.length
                            ?
                                <div className="deposit__list">
                                    <div className="table__row table__row--header deposit__item">
                                        <div className="table__cell">Дата</div>
                                        <div className="table__cell">Депозит</div>
                                        <div className="table__cell"/>
                                    </div>
                                    {
                                        deposit_list.list.map(elem => {
                                            return (
                                                <div className="deposit__item table__row" key={ elem.id }>
                                                    <ContextMenu data={{
                                                        open: elem.id === context,
                                                        style: { right: 28 },
                                                        menu
                                                    }}/>
                                                    <div className="table__cell">{ elem.date }</div>
                                                    <div className="table__cell">{ elem.sum }</div>
                                                    <i className="menu__button" onClick={ event => {
                                                        event.preventDefault();
                                                        event.stopPropagation();
                                                        dispatch(contextAction(elem.id));
                                                    } }/>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            :
                                <div className="deposit__empty">Нет данных</div>
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => dispatch(setDepositFormAction({
                                ...DEPOSIT_FORM_INITIAL,
                                open: true
                            })) }
                        >
                            Новый депозит
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DepositsList;